export default "__VITE_ASSET__f46c5802__"